import { render, staticRenderFns } from "./AdminSuspendAccountDialog.vue?vue&type=template&id=1eb66bdc&scoped=true"
import script from "./AdminSuspendAccountDialog.vue?vue&type=script&lang=js"
export * from "./AdminSuspendAccountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb66bdc",
  null
  
)

export default component.exports